export default "__VITE_ASSET__BCFWwDty__"